import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import bagHeartImgUrl from "./assets/images/bag_heart.png";
import ufbaGroupImgUrl from "./assets/images/ufba_group.png";

export function HomePage() {
  const { t } = useTranslation("global");

  return (
    <main>
      <section className="py-5 text-center" style={{ backgroundColor: "#e1d3e6" }}>
        <div className="row pt-lg-5">
          <div className="col-lg-6 col-md-8 mx-auto">
            <h1 className="fw-light"></h1>

            <p
              className="lead"
              style={{
                color: "#6A2481",
                fontWeight: "400",
                fontSize: "16px",
              }}
            >
              {/* Utilizando a tradução aqui */}
              {t("homePage.objetivoDoAplicativo")}
            </p>
            <p>
              {/* Button trigger modal */}
              <button
                type="button"
                className="btn btn-danger text-uppercase"
                //onClick={() => (window.location.href = "/treinamentos")}
              >
                <Link to="/treinamentos" style={{ color: "white", textDecoration: "none" }}>
                  Saiba Mais
                </Link>
              </button>
            </p>
          </div>
        </div>
      </section>

      {/* Primeiros socorros na escola */}
      <div className="album py-5">
        <div className="container">
          <img src={bagHeartImgUrl} />{" "}
          <span
            style={{
              color: "#6A2481",
              textAlign: "right",
              fontFamily: "Poppins",
              fontSize: "18.5px",
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "normal",
            }}
          >
            {/* Utilizando a tradução aqui */}
            {t("homePage.primeirosSocorrosNaEscola")}
          </span>
          <div className="pt-2" style={{ textAlign: "justify" }}>
            <p>
              {/* Utilizando a tradução aqui */}
              {t("homePage.primeirosSocorrosEscola")}
            </p>
          </div>
        </div>
      </div>
      <div className="modal-body">
        <p
          align="center"
          style={{
            color: "#1E1E1E",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "150%",
          }}
          className="p-2"
          dangerouslySetInnerHTML={{ __html: t("homePage.aplicacaoDoProduto") }}
        />
        <div className="container my-2 py-2"> </div>
        <p className="text-center">
          <img src={ufbaGroupImgUrl} style={{ textAlign: "justify" }} />
        </p>
      </div>
    </main>
  );
}
